import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { ensureKnown, answerQuery } from '../../store/knownDataSlice';
import AnswerQuery from '../parts/AnswerQuery';
import QueryDetails from '../parts/QueryDetails';
import EditQuery from '../parts/EditQuery';
import FoodPackages from '../parts/FoodPackages';
import AllNotes from '../parts/AllNotes';
import PrivateNotes from '../parts/PrivateNotes';




function QueryView(props) {
    const id = useParams()["id"].toUpperCase();
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);

    const data = useSelector((state) => state.knownData[id]);



    if(!data) return;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Päring</h1>
                        <p>(vastamata)</p>
                    </div>
                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>

                <QueryDetails id={id} />

                <FoodPackages id={id} />

                <AllNotes id={id} showClientNotes={true} showLogisticsNotes={false} showDriverNotes={false} />

                <PrivateNotes id={id} />

                <AnswerQuery id={id} />

                <EditQuery id={id} />

            </div>

        </div>
    );
};

export default QueryView;